import { MultiStepModal } from './atoms/modal/modal.component';
import { Step } from './atoms/step/step';
import { MultiStepStepper } from './atoms/stepper/stepper';
import { MultiStepStepperItem } from './atoms/stepper/stepper-item';
import { MultiStepRoot } from './multi-step.component';

export { MultiStepContext, useMultiStepContext } from './multi-step.context';
export {
  useMultiStepControl,
  useMultiStepModalControl,
  type MultiStepControlProps,
  type MultiStepControl,
  type MultiStepModalControl,
} from './multi-step.hooks';
export {
  default as MultiStepProvider,
  type MultiStepProviderProps,
  type MultiStepProviderRef,
} from './multi-step.provider';
export type {
  ToNamespace,
  MultiStepDisplay,
  MultiStepActionButtonProps,
  MultiStepActionButton,
  StepData,
  PrevSteps,
  PrevNextStepProps,
  StepCallbackProps,
  PrevNextStepMethod,
} from './multi-step.types';
export { StepCloseButton, type StepButtonProps } from './atoms/step/step-close-button';
export { StepContext, useStepContext } from './atoms/step/useStepContext';
export type * from './multi-step.component';
export type * from './atoms/modal/modal.component';
export type * from './atoms/stepper/stepper';
export type * from './atoms/stepper/stepper-item';
export type * from './atoms/step/step';
export type * from './atoms/step/step-body';
export type * from './atoms/step/step-footer';
export type * from './atoms/step/step-header';

const MultiStepNamespace = {
  Root: MultiStepRoot,
  Step,
  Stepper: MultiStepStepper,
  StepperItem: MultiStepStepperItem,
  Modal: MultiStepModal,
};

export { MultiStepNamespace as MultiStep };
